/**
 * @architecture-header 1
 * @layer routes
 * @domain workspace-shell
 * @responsibility Render the shortcut reference sheet.
 * @state-owner overlay host
 * @allowed-imports React; shared components and hooks
 * @forbidden business rules; network
 * @public-api ShellKeyboard
 * @side-effects none
 * @tests workspace Playwright flows in frontend/apps/web/e2e/workspace.spec.ts
 */

import { ModalDocument, SectionLabel } from '../../shared/components/Modal';
import { useTranslator } from '../../shared/model/use-workspace';

const GROUPS: readonly (readonly [string, readonly (readonly [string, string])[]])[] = [
  [
    '導覽',
    [
      ['⌘ K', '命令面板'],
      ['G A', '去活動'],
      ['G C', '去班級'],
      ['G L', '去即時'],
      ['G R', '去報告'],
      ['⌘ \\', '收合清單'],
      ['esc', '返回上一層'],
    ],
  ],
  [
    '動作',
    [
      ['E', '編輯這一份'],
      ['⌘ ↵', '送出'],
      ['?', '這張表'],
    ],
  ],
  [
    '卷面',
    [
      ['⌘ +', '放大'],
      ['⌘ -', '縮小'],
      ['⌘ 0', '還原 100%'],
    ],
  ],
];

export function ShortcutsDialog() {
  const t = useTranslator();
  return (
    <ModalDocument
      maxWidth={560}
      subtitle={t('幾乎每個動作都有，手不用離開鍵盤')}
      title={t('快捷鍵')}
    >
      {GROUPS.map(([group, rows]) => (
        <div key={group}>
          <SectionLabel first>{t(group)}</SectionLabel>
          <div className="kgrid">
            {rows.map(([keys, label]) => (
              <div className="krow" key={label}>
                <span>{t(label)}</span>
                <span className="kk9">
                  {keys.split(' ').map((key) => (
                    <kbd key={key}>{key}</kbd>
                  ))}
                </span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </ModalDocument>
  );
}
